<script setup lang="ts">
import { DtInstallBanner } from '@/design-system';
import PushNotifications from '@/components/PushNotifications.vue';
</script>

<template>
  <PushNotifications />
  <DtInstallBanner />
</template>